module.exports = __webpack_public_path__ + "static/img/6981ef64-98ef-4891-9f7c-343b2875ecdb.2bcc02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/6981ef64-98ef-4891-9f7c-343b2875ecdb.png
// module id = lX7u
// module chunks = 0